module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisible,
      "title": "导入列表",
      "name": "uploadName",
      "width": "300px",
      "custom-class": "dialog"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('a', [_vm._v("文件*")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.uploadFileName),
      expression: "uploadFileName"
    }],
    staticStyle: {
      "width": "80%"
    },
    style: ({
      'border-color': _vm.isEmpty ? 'red' : '#ddd'
    }),
    attrs: {
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.uploadFileName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.uploadFileName = $event.target.value
      }
    }
  }), (_vm.uploadPercentage == 100) ? _c('a', {
    staticClass: "cancelUpload",
    on: {
      "click": _vm.cancelUpload
    }
  }, [_vm._v("X")]) : _vm._e(), _vm._v(" "), (_vm.isUploaded) ? _c('el-progress', {
    attrs: {
      "percentage": _vm.uploadPercentage
    }
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "tip",
    staticStyle: {
      "margin-top": "14px"
    }
  }, [_vm._v("*只支持xls和xlsx文件")]), _vm._v(" "), _c('div', {
    staticClass: "dislogFooter"
  }, [_c('div', {
    staticClass: "uploadBox"
  }, [_vm._v("\n    浏览\n    "), _c('input', {
    ref: "inputer",
    staticClass: "upload",
    attrs: {
      "type": "file"
    },
    on: {
      "change": function($event) {
        _vm.upload()
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "leadIn",
    on: {
      "click": _vm.uploadToServer
    }
  }, [_vm._v("导入")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-231b8996"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AccountAdmin/dataSTS/Upload.vue
// module id = 1433
// module chunks = 7